import { Link } from "react-router-dom";

const zones = [
  "France",
  "Europe",
  "Afrique",
  "Amérique",
  "Asie",
  "Océanie",
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 text-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-4">
            <a
              href="#top"
              className="flex items-center gap-3 mb-6 group"
              aria-label="PDR France - Retour en haut"
            >
              <img
                src="/assets/logo-pdr-france.jpeg"
                alt="PDR France"
                className="h-14 w-14 object-cover border border-white/10 group-hover:border-white/30 transition-colors"
              />
              <div className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black uppercase tracking-[0.15em]">
                  PDR <span className="text-[#EF4135]">FRANCE</span>
                </span>
                <span className="text-[10px] uppercase tracking-[0.3em] text-white/50 mt-1.5">
                  Débosselage sans peinture
                </span>
              </div>
            </a>
            {/* French flag bar */}
            <div className="flex items-center gap-1 mb-6">
              <div className="h-[3px] w-10 bg-[#0055A4]" />
              <div className="h-[3px] w-10 bg-white" />
              <div className="h-[3px] w-10 bg-[#EF4135]" />
            </div>
            <p className="text-sm text-white/60 leading-relaxed max-w-sm mb-6">
              Spécialiste international du débosselage sans peinture. Partenaire des
              compagnies d'assurance et des constructeurs automobiles depuis
              plus de 15 ans.
            </p>
            <div className="space-y-3 text-sm">
              <a
                href="tel:+33773119016"
                className="flex items-center gap-2 text-white/70 hover:text-[#007AFF] transition-colors"
              >
                <span className="text-[10px] uppercase tracking-[0.3em] text-[#007AFF]">Tél.</span>
                <span className="font-semibold">07 73 11 90 16</span>
              </a>
              <a
                href="mailto:debosselage@pdrfrance.fr"
                className="flex items-center gap-2 text-white/70 hover:text-[#007AFF] transition-colors"
              >
                <span className="text-[10px] uppercase tracking-[0.3em] text-[#007AFF]">Email</span>
                <span className="font-semibold">debosselage@pdrfrance.fr</span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.3em] text-[#007AFF] mb-4">
              Services
            </div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#services" className="hover:text-white">Débosselage DSP</a></li>
              <li><a href="#services" className="hover:text-white">Smart Repair</a></li>
              <li><a href="#services" className="hover:text-white">Gestion sinistres</a></li>
              <li><a href="#services" className="hover:text-white">Atelier mobile</a></li>
              <li><a href="#services" className="hover:text-white">Flottes</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.3em] text-[#007AFF] mb-4">
              Entreprise
            </div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#process" className="hover:text-white">Processus</a></li>
              <li><a href="#cibles" className="hover:text-white">Nos clients</a></li>
              <li><a href="#partenaires" className="hover:text-white">Partenaires</a></li>
              <li><a href="#contact" className="hover:text-white">Contact</a></li>
              <li><a href="#" className="hover:text-white">Carrières</a></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-[#007AFF] mb-4">
              Zones couvertes
            </div>
            <div className="flex flex-wrap gap-2">
              {zones.map((r) => (
                <span
                  key={r}
                  className="text-[11px] uppercase tracking-wider text-white/60 border border-white/10 px-3 py-1.5"
                >
                  {r}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="h-px bg-white/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-white/50">
          <div>
            © {new Date().getFullYear()} PDR FRANCE. Tous droits réservés.
          </div>
          <div className="flex flex-wrap gap-6">
            <Link to="/mentions-legales" data-testid="footer-mentions-legales" className="hover:text-white">Mentions légales</Link>
            <Link to="/confidentialite" data-testid="footer-confidentialite" className="hover:text-white">Politique de confidentialité</Link>
            <Link to="/cgu" data-testid="footer-cgu" className="hover:text-white">CGU</Link>
            <Link to="/cookies" data-testid="footer-cookies" className="hover:text-white">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
